import { c as _c } from "react/compiler-runtime";
import { getOrgPlaybooksOptions } from '@onefootprint/fetch-dashboard';
import type { OnboardingConfigKind } from '@onefootprint/types';
import { useQuery } from '@tanstack/react-query';
type UsePlaybookOptionsArgs = {
  kinds?: OnboardingConfigKind[];
};

/** @deprecated Use `usePreloadPlaybooks` instead */
const usePlaybookOptions = t0 => {
  const $ = _c(4);
  const {
    kinds
  } = t0;
  let t1;
  if ($[0] !== kinds) {
    t1 = getOrgPlaybooksOptions({
      query: {
        kinds: kinds?.join(","),
        pageSize: 100
      }
    });
    $[0] = kinds;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = {
      ...t1,
      select: _temp2
    };
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return useQuery(t2);
};
export default usePlaybookOptions;
function _temp(t0) {
  const {
    publishedVersion: t1
  } = t0;
  const {
    playbookId,
    name,
    key
  } = t1;
  return {
    label: name,
    value: playbookId,
    key
  };
}
function _temp2(response) {
  return response.data?.map(_temp) || [];
}